import integration from '../integration';
import interrupter from '../interrupter';
import events from './events';

const initializeEvents = () => {
  integration.initializers.setupMessages();
  interrupter.initializers.setupMessages();

  events.emit({ action: 'ws:ready' });
};

export default initializeEvents;
